﻿module.exports = (function ($) {
    return {
        init: function () {
            var self = this; // Used to reference 'this' inside anonymous functions (e.g. click events)
            // event map.
            if ($('.eventLocation__map').length > 0) {
                self.createEventMap($('.eventLocation__map').attr('data-lat'), $('.eventLocation__map').attr('data-long'), $('.eventLocation__map').attr('data-pin-colour'), 'event-google-map', $('.eventLocation__map').attr('data-address'), 13);
            }

            if($('.otherLocations__map').length > 0)
            {
                $('.otherLocations__map').each(function () {
                    self.createEventMap($(this).attr('data-lat'), $(this).attr('data-long'), $(this).attr('data-pin-colour'), $(this).attr('id'), $(this).attr('data-address'), 5);
                });
            }
        },
        createEventMap: function (lat, lng, pinColour, mapElementId, address, zoom) {

            var iconUrl = window.location.protocol + "//" + window.location.hostname + "/assets/images/maps/retina/event-pin-" + pinColour + ".png";

            // Create new lat/long
            var latLng = new google.maps.LatLng(lat, lng);

            var mapOptions = {
                zoom: zoom,
                panControl: false,
                streetViewControl: false,
                mapTypeControl: false,
                fullscreenControl: false,
                scrollwheel: false,
                maxZoom: 16,
                center: latLng,
                zoomControl: false,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.TOP_LEFT
                },
                styles: [
                    {
                        "featureType": "administrative",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "off"
                            },
                            {
                                "color": "#95aabb"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#444444"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.province",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.province",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ababab"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.man_made",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.man_made",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.man_made",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.natural.terrain",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "all",
                        "stylers": [
                            {
                                "saturation": -100
                            },
                            {
                                "lightness": 45
                            },
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "weight": "1"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            },
                            {
                                "weight": "1.5"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            },
                            {
                                "weight": "0.25"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            },
                            {
                                "weight": "1.15"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#46bcec"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#95aabb"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            }
                        ]
                    }
                ]
            };

            // Set up google map
            var map = new google.maps.Map(document.getElementById(mapElementId), mapOptions);

            // Build a marker image of retina compatibility
            var mapIcon = {
                url: iconUrl,
                anchor: new google.maps.Point(22, 59.5),
                scaledSize: new google.maps.Size(58, 59.5)
            };

            google.maps.event.addDomListener(window, "resize", function () {
                google.maps.event.trigger(map, "resize");
            });

            function callback(results, status) {
                if (status === google.maps.places.PlacesServiceStatus.OK) {
                    for (var i = 0; i < results.length; i++) {
                        createMarker(results[i]);
                    }
                }
            }

            function createMarker(place) {
                var marker = new google.maps.Marker({
                    map: map,
                    icon: mapIcon, // Get a custom one made
                    position: place.geometry.location,
                    url: 'https://www.google.com/maps/search/?api=1&zoom=16&query=' + place.geometry.location.lat() + ',' + place.geometry.location.lng() + '&query_place_id=' + place.place_id
                });
                map.setCenter(place.geometry.location);
                google.maps.event.addListener(marker, 'click', function () {
                    window.open(this.url, '_blank');
                });
            }
            
            if (address)
            {
                var request = {
                    location: map.getCenter(),
                    radius: '500',
                    query: address
                };

                var service = new google.maps.places.PlacesService(map);
                service.textSearch(request, callback);
            }
            else
            {
                // Add marker
                var marker = new google.maps.Marker({
                    position: latLng,
                    map: map,
                    icon: mapIcon, // Get a custom one made
                    url: 'https://www.google.com/maps/search/?api=1&zoom=16&query=' + latLng.lat() + ',' + latLng.lng()
                });

                google.maps.event.addListener(marker, 'click', function () {
                    window.open(this.url, '_blank');
                });
            }

            
        }
    }
});